import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CrateStateEnum } from 'src/models/Crate';

interface SearchApiResponse {
  description: string;
  name: string;
  sku: string;
}

type ProductCountResponse = {
  sku: string;
  quantity: number;
}

@Injectable({
  providedIn: 'root'
})
export class V3ProductsDataSourceService {

  constructor(private http: HttpClient) { }

  getV3SearchedProducts(searchTerm: string, searchColumns: ('sku' | 'name' | 'description')[]) {
    let params = new URLSearchParams();
    params.append('search', searchTerm);
    searchColumns.forEach(col => params.append('searchColumns', col));
    return this.http.get<SearchApiResponse[]>(
      environment.v3BaseUrl + '/api/v3/admin-desktop/products/search?' + params.toString()
    ).toPromise();
  }

  getV3ProductsCount(groundPositionTypes: string[], params: { skus: string[], palletStates: CrateStateEnum[] }) {
    let httpParams = params ? { ...params } : {};
    if (groundPositionTypes && groundPositionTypes.length) {
      httpParams = { ...httpParams, groundPositionTypes };
    }
    return this.http.get<ProductCountResponse[]>(`${environment.v3BaseUrl}/api/v3/admin-desktop/products/count`, { params: httpParams }).toPromise();
  }
}
